var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGoldLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 472,
    viewBox: "0 0 545 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.781 466.033L139.806 466.349L6.50256 236.339L139.219 5.96723L405.194 5.65079L538.452 235.661L405.781 466.033Z",
    stroke: "#FFC300",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.479 351.887L270.445 461.648L77.3992 346.462L79.3409 121.47L274.374 11.6632L467.465 126.894L465.479 351.887Z",
    stroke: "#FFC300",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.019 167.58H267.284V239.91H280.019V167.58Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.748 143.033H266.923V155.284H279.748V143.033Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.652 219.839H145.677L136.645 240.408H122.827L165.501 143.304H183.925L227.456 240.408H213.909L204.652 219.839ZM200.813 211.611L174.983 152.255L149.47 211.611H200.813Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.201 240.408V143.304H383.835C396.358 143.304 405.179 145.369 410.297 149.498C415.399 153.611 417.973 160.799 417.973 170.971C417.973 180.012 416.573 186.205 413.774 189.731C409.487 193.937 403.786 196.388 397.788 196.603C410.161 197.386 416.348 203.655 416.348 215.408V240.227H403.026V218.076C403.026 206.714 397.141 201.048 385.37 201.078H341.342V240.408H328.201ZM341.342 191.811H379.319C389.344 191.811 396.162 190.545 399.82 188.013C401.828 186.251 403.375 184.024 404.328 181.527C405.28 179.029 405.608 176.336 405.284 173.683C405.284 164.913 403.929 159.172 401.22 156.55C398.511 153.928 392.866 152.572 383.835 152.572H341.342V191.811Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M351.367 270.018H391.556C394.401 270.018 413.096 269.204 416.98 280.054C416.98 280.054 420.773 286.066 419.463 303.651C419.463 303.651 418.56 317.213 413.367 321.734C413.367 321.734 409.123 326.661 396.84 327.023H352.225V318.524H358.005H392.911C392.911 318.524 403.884 318.524 406.82 314.411C406.82 314.411 409.981 310.297 409.393 295.198C409.393 295.198 409.393 284.665 406.323 281.636C406.323 281.636 404.652 278.381 390.744 278.607H351.457L351.367 270.018Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368.843 276.528H357.869V319.745H368.843V276.528Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.527 300.532H185.37C185.434 301.797 185.434 303.064 185.37 304.329C185.37 314.094 183.789 320.152 180.583 322.412C177.377 324.672 169.068 325.893 155.566 325.893C142.832 325.893 134.643 324.507 131.001 321.734C127.358 318.961 125.552 312.813 125.582 303.29V295.288V290.496C125.582 282.45 127.569 276.934 131.633 274.448C135.697 271.962 143.825 270.47 156.063 270.47C168.3 270.47 176.248 271.329 179.815 273.092C183.383 274.855 185.189 277.612 185.189 283.534H177.557C177.557 279.014 175.932 278.245 173.493 277.206C167.289 275.81 160.916 275.323 154.572 275.759C145.18 275.759 139.264 276.573 136.916 278.245C134.568 279.918 133.349 284.167 133.349 290.903V298.091V305.821C133.349 312.693 134.658 316.897 137.277 318.434C139.896 320.016 146.941 320.785 158.321 320.785C167.036 320.785 172.455 320.061 174.487 318.569C176.519 317.078 178.777 314.953 177.603 306.906C177.603 306.409 177.603 308.217 177.241 306.499H154.302L154.527 300.532Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236.532 270.696C250.2 270.696 258.75 272.203 262.182 275.217C265.614 278.23 267.314 285.765 267.284 297.82C267.284 310.719 265.644 318.675 262.362 321.689C259.081 324.703 250.471 326.209 236.532 326.209C222.669 326.209 213.954 324.672 210.748 321.689C207.542 318.705 205.735 310.884 205.735 298.362V294.565V289.411C205.401 286.597 205.829 283.745 206.973 281.152C208.116 278.56 209.935 276.322 212.238 274.674C216.754 272.052 224.746 270.696 236.532 270.696ZM236.532 275.895C225.123 275.895 218.439 276.844 216.483 278.743C214.541 280.641 213.547 287.196 213.547 298.362C213.547 309.528 214.541 316.174 216.483 318.072C218.424 319.971 225.108 320.92 236.532 320.92C247.957 320.92 254.595 319.971 256.672 318.072C258.75 316.174 259.562 309.619 259.562 298.362V289.728C259.562 283.715 258.208 279.918 255.544 278.291C252.879 276.663 246.467 275.759 236.487 275.759L236.532 275.895Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M299.391 271.238V319.835H336.555V325.486H291.398V271.238H299.391Z",
    fill: "#FFC300",
    stroke: "#FFC300",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGoldLogo);
export default __webpack_public_path__ + "static/media/airGoldLogo.579b7c9a44485c4b6758a78411bd71d3.svg";
export { ForwardRef as ReactComponent };